import { render } from "./day-two.vue?vue&type=template&id=2f4d939c"
import script from "./day-two.vue?vue&type=script&lang=js"
export * from "./day-two.vue?vue&type=script&lang=js"

import "./day-two.vue?vue&type=style&index=0&id=2f4d939c&lang=scss"
script.render = render

export default script